import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import {
    DigestFilter,
    DigestFilterColumn,
    DigestFilterOperator,
    DigestLogicalFilter,
    DigestLogicalOperator,
} from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

export interface PicklistDataItem {
    [columnName: string]: string | number;
}

export interface PicklistColumnMeta {
    name: string;
    withMarkdown: boolean;
}

export interface PicklistQueryResponse {
    items: PicklistDataItem[];
    suitableCount: number;
    columnMetas: PicklistColumnMeta[];
}

export const emptyPicklistQueryResponse = (): PicklistQueryResponse => ({
    items: [],
    suitableCount: 0,
    columnMetas: [],
});

export function isPicklistFilterColumn(filter: DigestFilter): filter is DigestFilterColumn {
    return (
        filter.operator === DigestFilterOperator.Equal ||
        filter.operator === DigestFilterOperator.Substring ||
        filter.operator === DigestFilterOperator.Prefix ||
        filter.operator === DigestFilterOperator.ContainsInList
    );
}

export function isPicklistLogicalFilter(filter: DigestFilter): filter is DigestLogicalFilter {
    return (
        (filter.operator === DigestLogicalOperator.Or || filter.operator === DigestLogicalOperator.And) &&
        Array.isArray(filter.operands)
    );
}

export function isPicklistFilter(filter: DigestFilter | DigestLogicalOperator): filter is DigestFilter {
    if (!isPicklistLogicalOperator(filter)) {
        return isPicklistFilterColumn(filter) || isPicklistLogicalFilter(filter);
    }

    return false;
}

export function isPicklistLogicalOperator(
    operator: DigestLogicalOperator | DigestFilterColumn | DigestLogicalFilter
): operator is DigestLogicalOperator {
    return operator === DigestLogicalOperator.Or || operator === DigestLogicalOperator.And;
}

export function unionWithAndFilters(
    filter1: DigestFilter | undefined,
    filter2: DigestFilter | undefined
): undefined | DigestFilter {
    return unionFilters([filter1, filter2], DigestLogicalOperator.And);
}

export function unionWithOrFilters(
    filter1: DigestFilter | undefined,
    filter2: DigestFilter | undefined
): undefined | DigestFilter {
    return unionFilters([filter1, filter2], DigestLogicalOperator.Or);
}

function unionFilters(
    filters: Array<DigestFilter | undefined>,
    operator: DigestLogicalOperator
): undefined | DigestFilter {
    const resultFilters = filters.filter(isNotNullOrUndefined);
    if (resultFilters.length === 0) {
        return undefined;
    }
    if (resultFilters.length === 1) {
        return resultFilters[0];
    }
    return {
        operator: operator,
        operands: resultFilters,
    };
}
